<!-- @if (showToolbar()) {
<orion-platform-toolbar class="orion-toolbar--top"></orion-platform-toolbar>
} -->

<div class="wrapper">
  <aside>
    <!-- Sidebar -->
    <orion-platform-sidebar
      [hidden]="!showSidebar()"
      [isCollapse]="isSidebarCollapse"
      (mouseenter)="onSidebarHover()"
      (mouseleave)="offSidebarHover()"></orion-platform-sidebar>
  </aside>

  <main>
    <!-- Main View -->
    @if (showToolbar()) {
    <orion-platform-toolbar class="orion-toolbar--top"></orion-platform-toolbar>
    }

    <div
      [ngClass]="{
        'orion-content-header-space': showToolbar(),
        'orion-content-full-height': !showToolbar()
      }"
      class="orion-content--container">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<orion-platform-signalr-notification></orion-platform-signalr-notification>

@if (showNotification()) {
<orion-platform-dashboard-notifier></orion-platform-dashboard-notifier>
}
